export const GET_COMPANIES = 'Get Companies';
export const COMPANIES_LOADING = 'Loading Companies';
export const SELECT_COMPANY = 'Select Company';
export const CLEAN = 'Clean Companies';
export type ActionType = 'Get Companies' | 'Select Company' | 'Clean Companies' | 'Loading Companies';
